import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Cookie from 'js-cookie';
import Cookies from 'js-cookie';

const SetCookie = (cookiename,usrin)=>{
   // console.log('Set cookie for consent');
    // Cookies.set(cookiename, usrin,{
        
    //     secure:true,
    //     httpOnly: true,
    //     sameSite: 'strict',
        
    // });
    Cookies.set(cookiename, usrin,{
        
        secure: true,
        //httpOnly: true,
        sameSite: 'strict',
        
    });
};
export default SetCookie;